import React from 'react'
import { Mail, MessageSquare, ShieldCheck } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export default function Contact() {
  const checklist = [
    'What you expected vs. what happened.',
    'Plan year and number of employees.',
    'Screenshots or CSV samples with sensitive data removed.',
  ]

  return (
    <div id="contact" className="space-y-8">

      <div className="grid gap-4 lg:grid-cols-[1.1fr_0.9fr]">
        <Card className="bg-background">
          <CardHeader className="pb-2">
            <CardTitle className="text-base flex items-center gap-2">
              <Mail className="h-4 w-4 text-brand" aria-hidden="true" />
              <span>Email the team</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <div className="rounded-lg border border-border/60 bg-muted/30 px-4 py-3">
              <div className="text-xs uppercase tracking-wide text-muted-foreground">Support &amp; bugs</div>
              <a
                href="mailto:support@retira.app"
                className="mt-1 inline-flex text-sm font-medium text-foreground underline underline-offset-4"
              >
                support@retira.app
              </a>
            </div>
            <div className="rounded-lg border border-border/60 bg-muted/30 px-4 py-3">
              <div className="text-xs uppercase tracking-wide text-muted-foreground">
                Questions, feedback &amp; everything else
              </div>
              <a
                href="mailto:hello@retira.app"
                className="mt-1 inline-flex text-sm font-medium text-foreground underline underline-offset-4"
              >
                hello@retira.app
              </a>
            </div>
            <Button asChild>
              <a href="mailto:support@retira.app">Send an email</a>
            </Button>
          </CardContent>
        </Card>

        <div className="space-y-4">
          <Card className="bg-background">
            <CardHeader className="pb-3">
              <CardTitle className="text-base flex items-center gap-2">
                <MessageSquare className="h-4 w-4 text-brand" aria-hidden="true" />
                <span>Include these details</span>
              </CardTitle>
              <CardDescription>Clear context helps us respond faster.</CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="list-disc space-y-2 pl-4 text-sm text-muted-foreground">
                {checklist.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-background">
            <CardHeader className="pb-3">
              <CardTitle className="text-base flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-brand" aria-hidden="true" />
                <span>Privacy reminder</span>
              </CardTitle>
              <CardDescription>Keep sensitive information out of email.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-3 text-sm text-muted-foreground">
              <p>
                Remove names and any other sensitive info before sending screenshots or CSV samples. Use
                placeholders instead.
              </p>
              <Button asChild variant="link" className="h-auto p-0 text-sm">
                <Link to="/privacy">Review privacy &amp; terms</Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
